import React from "react";
import { Box } from "@chakra-ui/react";

export const DropDragIcon = (props) => {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#424770"
        viewBox="0 0 24 24"
        width="20px"
        height="20px"
      >
        <path d="M 12 2 L 8 6 L 11 6 L 11 11 L 6 11 L 6 8 L 2 12 L 6 16 L 6 13 L 11 13 L 11 18 L 8 18 L 12 22 L 16 18 L 13 18 L 13 13 L 18 13 L 18 16 L 22 12 L 18 8 L 18 11 L 13 11 L 13 6 L 16 6 L 12 2 z" />
      </svg>
    </Box>
  );
};
